// src/utils/postLogout.ts
// Redirection de connexion « selon le profil » — build CGE-GUI uniquement.
//
// À la connexion, on mémorise l'ESPACE de l'utilisateur (adhérent vs agent)
// d'après le nom de son profil (`profilNom`, renvoyé par l'API d'auth).
// À la déconnexion / expiration de session, on renvoie sur la bonne page :
//   - profil « Adherant »  → /connexion            (espace adhérent)
//   - tout autre profil    → /acces-collaborateurs (espace agents / back-office)
// Hors build CGE-GUI (IS_CGEGUI=false) : comportement historique (/login).
//
// La clé `cgegui_espace` N'EST PAS effacée au logout (contrairement au user),
// pour que la redirection connaisse encore l'espace après nettoyage de session.
import { IS_CGEGUI } from '../data/tenantFlag';

const KEY = 'cgegui_espace';

/** Vrai si le nom de profil désigne un adhérent (tolère « Adherant »/« Adhérent »). */
const isAdherentProfil = (nom?: string | null): boolean =>
  /adh[ée]ra?nt/i.test(nom || '');

/** À la connexion : mémorise l'espace (adhérent/agent) d'après le profil. */
export function rememberEspaceFromUser(user: any): void {
  if (!IS_CGEGUI) return;
  try {
    localStorage.setItem(KEY, isAdherentProfil(user?.profilNom) ? 'adherent' : 'agent');
  } catch { /* localStorage indispo */ }
}

/** Page de connexion à afficher (déconnexion / non-authentifié). */
export function loginPathForBuild(): string {
  if (!IS_CGEGUI) return '/login';
  let espace = 'agent';
  try { espace = localStorage.getItem(KEY) || 'agent'; } catch { /* noop */ }
  return espace === 'adherent' ? '/connexion' : '/acces-collaborateurs';
}
